import Screens from '../../';
export var checkToStopAutoSpin = function checkToStopAutoSpin(modal) {
  var blockedScreens = [Screens.BattlesCollectGame, Screens.BattlesCollectStreak];
  return blockedScreens.includes(modal);
};